// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__9SSYX","logo":"footer_logo__vRglU"};